/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { format } from 'fecha';

import { addDays } from './day-date';
import { addMsModulo, getMillisecondsOfDay } from './iso-time-string';

/**
 * @import { DayDate } from './day-date'
 * @import { ISOTimeString } from './iso-time-string'
 */

/**
 * ISO 8601 lokální datetime v rozsahu roků 0100-9999.
 * @typedef {`${number}-${number}-${number}T${number}:${number}:${number}`} ISOLocalString
 */

/**
 * Přičte milisekundy k datu bez timezone problémů.
 * Pracuje přímo s logickými časy (den + čas), nikoli s absolutními timestampy.
 * @param {ISOLocalString} date
 * @param {number} ms
 * @returns {ISOLocalString}
 * @throws {RangeError} Pokud je výsledné datum mimo povolený rozsah (100-9999).
 */
export function addMs(date, ms) {
  const time = getISOTimeString(date);
  const dayDate = getDayDate(date);

  const newTime = addMsModulo(time, ms);

  const currentMs = getMillisecondsOfDay(time);
  const totalMs = currentMs + ms;
  const daysToAdd = Math.floor(totalMs / (24 * 3600 * 1000));

  const newDayDate = addDays(dayDate, daysToAdd);
  return /** @type {ISOLocalString} */ (`${newDayDate}T${newTime}`);
}

/**
 * @param {Date} date
 * @returns {ISOLocalString}
 */
export function formatISOLocalString(date) {
  return /** @type {ISOLocalString} */ (
    format(date, 'isoDateTime').substring(0, 19)
  );
}

/**
 * @param {ISOLocalString} value
 * @returns {DayDate}
 */
export function getDayDate(value) {
  return /** @type {DayDate} */ (value.substring(0, 10));
}

/**
 * @param {ISOLocalString} value
 * @returns {ISOTimeString}
 */
export function getISOTimeString(value) {
  return /** @type {ISOTimeString} */ (value.substring(11));
}
